/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Results_TextInputs */



/**
* | output |
* | --- |
* | "Copy Text" |
*
* @param {Share_Results_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const share_results_text = /** @type {((inputs?: Share_Results_TextInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Results_TextInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier le texte")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar texto")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Copiar texto")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia testo")
	return /** @type {LocalizedString} */ ("Copy Text")
});